/**
 * API and media base URL.
 * Dev: empty (uses proxy in vue.config.js)
 * Prod: https://pesok24.pro
 */
export const API_BASE = process.env.VUE_APP_API_BASE || ''
